export default __webpack_public_path__ + "static/style-tip-accessories-ab325dc85717ceca03a7449e6e42c2a1.png";